export function getAllAgreements(axiosPrivate) {
  return axiosPrivate.get('/v2/trade-data-agreement/list-agreements')
}

export function deleteAgreement(axiosPrivate, id) {
  return axiosPrivate.delete(`/v2/trade-data-agreement/${id}/delete`)
}

export function exportAgreements(
  axiosPrivate,
  type: 'current-page' | 'all',
  params?: {search?: string; status?: string; page?: number; pageSize?: number}
) {
  return axiosPrivate.get(`/v2/trade-data-agreement/export/${type}`, {
    params,
    responseType: 'blob', // important for file download
  })
}
